import { render, staticRenderFns } from "./PorchTile.vue?vue&type=template&id=02adb5b8&scoped=true&"
import script from "./PorchTile.vue?vue&type=script&lang=js&"
export * from "./PorchTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02adb5b8",
  null
  
)

export default component.exports